<template>
    <div>
        <div class="mortgage-calculator-new">
            <div class="_w-509">
                <h2 class="h2">Рассчитать стоимость</h2>
                <h4 class="h4 _mt-32">Параметры</h4>
                <d-multi-select
                    :items="[
                        {'const': 'life', title: 'Страхование жизни'},
                        {'const': 'property', title: 'Страхование имущества'},
                        {'const': 'titul', title: 'Страхование титула'}
                    ]"
                    v-model="insurance"
                    :no-scroll="true"
                    static-label="Вид страхования"
                    class="_mt-24"
                />
                <div class="_mt-24full">
                    <div class="noUi noui_pb">
                        <div class="noUi__input">
                            <input type="text" v-model.lazy="summ" ref="realtyInput" inputmode="numeric" v-money v-mask-numeric class="noUi__text">
                            <label class="mortgage-mini-calculator__label form__label">Сумма кредита</label>
                            <div ref="mortgagePrice"></div>
                        </div>
                        <span class="noUi__start noUi_blur"> {{ summPeriods.min | numFormat('0,0 a') }} </span>
                        <span class="noUi__middle noUi__middle_ml-47 noUi_blur"> {{ summPeriods.middle | numFormat('0,0 a') }} </span>
                        <span class="noUi__end noUi_blur"> {{ summPeriods.max | numFormat('0,0 a') }} </span>
                    </div>
                </div>
                <h4 class="h4 _mt-32"
                    v-show="!((insurance.includes('property') || insurance.includes('titul')) && insurance.length === 1)
                    && !(insurance.includes('property') && insurance.includes('titul') && insurance.length === 2)"
                >
                    Данные заемщика
                </h4>
                <div class="_dgrid _grid-cols-2-1 _gap-32 _mt-24"
                    v-show="!((insurance.includes('property') || insurance.includes('titul')) && insurance.length === 1)
                    && !(insurance.includes('property') && insurance.includes('titul') && insurance.length === 2)"
                >
                    <ui-form-field
                        :value="$v.gender.$model"
                        :errors="vuelidateErrorMesages.gender"
                    >
                        <template v-slot:default="{ id, errors }">
                            <d-select-search-stable
                                :id="id"
                                v-model="$v.gender.$model"
                                placeholder="Пол"
                                :list="items"
                                :max-height="200"
                                :is-error="errors.length > 0"
                            />
                        </template>
                    </ui-form-field>
                    <ui-form-field
                        label="Дата рождения"
                        :value="$v.birthDate.$model"
                        :errors="vuelidateErrorMesages.birthDate"
                    >
                        <template v-slot:default="{ id, errors }">
                            <ui-date-picker
                                :id="id"
                                v-model="$v.birthDate.$model"
                                :error="errors.length > 0"
                            />
                        </template>
                    </ui-form-field>
                    <!-- <div class="form__item">

                        <div class="form__input date-input">
                            <input
                                id="birthDate"
                                v-model="birthDate"
                                format="DD.MM.YYYY"
                                valueType="DD.MM.YYYY"
                                inputmode="numeric"
                                class="d-input js-birth-date"
                                v-mask="'##.##.####'"
                                @focus="showLabel = false"
                                @blur="showLabel = true"
                            >
                            <div class="form__input-calendar"></div>
                            <label
                            for="birthDate"
                            class="d-select__label"
                            v-show="!birthDate && showLabel"
                            >
                                <span>Дата рождения</span>
                            </label>
                            <p class="form-error" v-if="trySubmit && age.target < age.min">Минимальный возраст страхования {{ age.min }} лет</p>
                            <p class="form-error" v-if="trySubmit && age.target > age.max">Максимальный возраст страхования {{ age.max }} лет</p>
                            <p class="form-error" v-if="trySubmit && (!birthDateValidation || birthDate.length < 10)">Введена некорректная дата или дата введена не полностью</p>
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="mortgage-calculator-new__right mortgage-calculator-new__right_mh461">
                <div class="mortgage-calculator-new__right-header _dflex _justify-content-between">
                    <div class="_align-self-start">
                        <p class="mortgage-calculator-new__right-par gray-text-light">Страховой взнос*</p>
                        <h2 class="mortgage-calculator-new__right-title _mt-8"><span v-if="insurancePremium">~ {{ insurancePremium | formatMoneyToInt }}</span></h2>
                    </div>
                    <div class="mortgage-calculator-new__right-header-rate">
                        <p class="mortgage-calculator-new__right-par gray-text-light">Срок <hint text=" Договор страхования заключается на весь срок кредитного договора с периодом страхования 1 год и ежегодной пролонгацией." /></p>
                        <h2 class="mortgage-calculator-new__right-title _mt-8">1 год</h2>
                    </div>
                </div>
                <div class="_mt-24full">
                    <div class="_dflex _justify-content-between _mb-16full">
                        <p class="mortgage-calculator-new__right-par gray-text-light">Жизнь</p>
                        <p class="mortgage-calculator-new__right-par"><span v-if="calculations.life === 0">не выбрано</span><span v-else>{{`~ ${calculations.life}` | formatMoneyToInt}}</span></p>
                    </div>
                    <div class="_dflex _justify-content-between _mb-16full">
                        <p class="mortgage-calculator-new__right-par gray-text-light">Имущество</p>
                        <p class="mortgage-calculator-new__right-par"><span v-if="calculations.property === 0">не выбрано</span><span v-else>{{`~ ${calculations.property}` | formatMoneyToInt}}</span></p>
                    </div>
                    <div class="_dflex _justify-content-between _mb-16full">
                        <p class="mortgage-calculator-new__right-par gray-text-light">Титул</p>
                        <p class="mortgage-calculator-new__right-par"><span v-if="calculations.titul === 0">не выбрано</span><span v-else>{{`~ ${calculations.titul}` | formatMoneyToInt}}</span></p>
                    </div>
                </div>
                <div class="_mt-24full">
                    <a @click.prevent="calculate" target="_blank" href="#" class="button button_green _w-100" :class="{'button-disabled': isDisabledBtn }">Рассчитать</a>
                </div>
                <div class="_mt-24full">
                    <p class="p4">*Расчет носит информационный характер и не является публичной офертой. Точный размер страховой премии будет рассчитан страховой компанией после заполнения анкеты на страхование и предоставления соответствующих документов</p>
                    <p v-if="insurance.includes('life')" class="p4 _mt-8">**Для предварительного расчета на сайте необходимо указать ваш пол и дату рождения</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import noUiSlider from 'nouislider';
import { extractVuelidateErrors } from '../../assets/js/vue/utlis/extractVuelidateErrors';
import vuelidateMessages from '../../assets/js/vue/validationsMessages';
import { required } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { ageMin, ageMax } from '../../assets/js/vue/validations';

export default {
    name: "mortgageInsuranceCalculator",
    mixins: [validationMixin],
    data() {
        return {
            insurance: ['life'],
            summ: 15000000,
            summPeriods: {
                min: 625000,
                middle: 15000000,
                max: 30000000,
            },
            gender: '',
            birthDate: '',
            birthDateValidation: false,
            items: [
                    { const: 'man', title: 'Мужской' },
                    { const: 'woman', title: 'Женский' }
                ],
            age: {
                target: null,
                min: 21,
                max: 70
            },
            trySubmit: false,
            calculations: {
                life: 0,
                property: 0,
                titul: 0
            },
            insurancePremium: 0,
            calcMatrix: [
                { age: 21, man: 0.00221, woman: 0.00171 },
                { age: 22, man: 0.00228, woman: 0.00171 },
                { age: 23, man: 0.00228, woman: 0.00171 },
                { age: 24, man: 0.0025, woman: 0.00179 },
                { age: 25, man: 0.0025, woman: 0.00179 },
                { age: 26, man: 0.0025, woman:  0.00192 },
                { age: 27, man: 0.00256, woman: 0.00192 },
                { age: 28, man: 0.00256, woman: 0.002 },
                { age: 29, man: 0.00287, woman: 0.002 },
                { age: 30, man: 0.00292, woman: 0.002 },
                { age: 31, man: 0.00307, woman: 0.00207 },
                { age: 32, man: 0.0032, woman: 0.00221 },
                { age: 33, man: 0.00329, woman: 0.00228 },
                { age: 34, man: 0.00357, woman: 0.00228 },
                { age: 35, man: 0.00371, woman: 0.0025 },
                { age: 36, man: 0.00405, woman: 0.00271 },
                { age: 37, man: 0.00427, woman: 0.00292 },
                { age: 38, man: 0.00449, woman: 0.003 },
                { age: 39, man: 0.00477, woman: 0.0032 },
                { age: 40, man: 0.00499, woman: 0.00329 },
                { age: 41, man: 0.00527, woman: 0.00349 },
                { age: 42, man: 0.00557, woman: 0.00371 },
                { age: 43, man: 0.00591, woman: 0.00393 },
                { age: 44, man: 0.0062, woman: 0.00421 },
                { age: 45, man: 0.00649, woman: 0.00442 },
                { age: 46, man: 0.00719, woman: 0.0047 },
                { age: 47, man: 0.00776, woman: 0.00506 },
                { age: 48, man: 0.00847, woman: 0.00542 },
                { age: 49, man: 0.00919, woman: 0.00578 },
                { age: 50, man: 0.01005, woman: 0.0062 },
                { age: 51, man: 0.01098, woman: 0.0067 },
                { age: 52, man: 0.01264, woman: 0.00764 },
                { age: 53, man: 0.01378, woman: 0.00818 },
                { age: 54, man: 0.01507, woman: 0.00894 },
                { age: 55, man: 0.01635, woman: 0.00961 },
                { age: 56, man: 0.01771, woman: 0.01037 },
                { age: 57, man: 0.01937, woman: 0.01136 },
                { age: 58, man: 0.0212, woman: 0.01226 },
                { age: 59, man: 0.02831, woman: 0.01937 },
                { age: 60, man: 0.03156, woman: 0.02167 },
                { age: 61, man: 0.03508, woman: 0.02411 },
                { age: 62, man: 0.03887, woman: 0.02668 },
                { age: 63, man: 0.0428, woman: 0.02925 },
                { age: 64, man: 0.04674, woman: 0.03183 },
                { age: 65, man: 0.0579, woman: 0.03441 },
                { age: 66, man: 0.08812, woman: 0.03936 },
                { age: 67, man: 0.06293, woman: 0.0423 },
                { age: 68, man: 0.06788, woman: 0.04526 },
                { age: 69, man: 0.07284, woman: 0.0482 },
                { age: 70, man: 0.07795, woman: 0.05115 }
            ]
        }
    },
    validations() {
        return {
            gender: {
                required,
            },
            birthDate: {
                required,
                ageMinInsurance: ageMin(this.age.min),
                ageMaxInsurance: ageMax(this.age.max),
            },
        };
    },
    computed: {
        vuelidateErrorMesages() {
            return extractVuelidateErrors(vuelidateMessages, this.$v).activeErrorMessages;
        },
        isDisabledBtn() {
            return this.insurance.includes('life') && (!this.gender.length || this.$v.gender.$error || !this.birthDate || !this.birthDate.length || this.$v.birthDate.$error)
        }
    },
    watch: {
        birthDate(value) {
            if (value && value.length === 10) {
                this.age.target = this.calcDate(value.split('.').reverse().join('-'));
                this.birthDateValidation = !this.age.target || (this.age.target < 0 || this.age.target > this.age.max) ? false : true;
            }
        }
    },
    methods: {
        calculate() {
            this.trySubmit = true;
            this.$v.$touch();
            this.calculations.property = this.calculations.life = this.calculations.titul = 0;

            if ((this.birthDateValidation && this.insurance.length && this.gender && this.age.target >= this.age.min && this.age.target <= this.age.max)
            || (this.insurance.includes('property') && this.insurance.length === 1)
            || (this.insurance.includes('titul') && this.insurance.length === 1)
            || (this.insurance.includes('property') && this.insurance.includes('titul') && this.insurance.length === 2)) {
                if (this.insurance.includes('property')) {
                    this.calculations.property = this.summ * 0.0012;
                }

                if (this.insurance.includes('life')) {
                    this.calcMatrix.forEach(element => {
                        if (element.age === this.age.target) {
                            this.calculations.life = this.summ * element[this.gender];
                        }
                    });
                }

                if (this.insurance.includes('titul')) {
                    this.calculations.titul = this.summ * 0.002;
                }
            }

            this.insurancePremium = this.calculations.property + this.calculations.life + this.calculations.titul;
        },
        calcDate(date) {
            const startDate = new Date();
            const endDate = new Date(date);
            const differenceMs = endDate.getTime() - startDate.getTime();
            const oneYearMs = 365 * 24 * 60 * 60 * 1000;
            const years = Math.floor(Math.abs(differenceMs / oneYearMs));
            return years
        }
    },
    mounted() {
        this.loanSlider = noUiSlider.create(this.$refs.mortgagePrice, {
            start: [this.summ],
            connect: 'lower',
            step: 1,
            initial: this.summ,
            range: {
                'min': this.summPeriods.min,
                'max': this.summPeriods.max
            },
            format: {
                to: (value) => {
                    return value + ',-';
                },
                from: (value) => {
                    return Number(value.replace(',-', ''));
                }
            }
        })

        this.loanSlider.on('change', (val) => {
            val = Number(val[0].replace(',-',''));
            this.summ = val;
        })

        this.loanSlider.on('update', (val) => {
            val = Number(val[0].replace(',-',''));
            this.summ = Math.round(val);
        })

        this.$refs.realtyInput.addEventListener('change', () => {
            this.loanSlider.set(this.summ);
        })
    },
}
</script>

<style scoped lang="scss">
    @import '../../assets/scss/base/_variables.scss';
    @import '../../assets/scss/base/_mixins.scss';
    @import '../../assets/scss/base/_functions.scss';

    .form__item {
        @include fluid('width', 280px);

        @include mobile {
            max-width: 100%;
        }
    }

    .form__input input {
        padding-top: 0px;
    }
</style>
